// Ohio BWC 2026 Fee Schedule Data - Parsed from ProfProviderFeeSchedule_0126_Proposed.xlsx
// CPT descriptions omitted due to AMA licensing requirements
// Source: https://dam.assets.ohio.gov/raw/upload/info.bwc.ohio.gov/Providers/ProfProviderFeeSchedule_0126_Proposed.xlsx

export interface FeeScheduleRow {
  cpt_code: string;
  modifier?: string;
  modifier_2?: string;
  coverage_flag?: string;
  non_facility_fee: number | null;
  facility_fee: number | null;
}

// Sample of orthopedic-relevant CPT codes from the 2026 schedule
// Full dataset would be loaded via database import
export const BWC_2026_SAMPLE_DATA: FeeScheduleRow[] = [
  // Surgery - Musculoskeletal System (commonly used in orthopedics)
  { cpt_code: '27447', non_facility_fee: 2850.23, facility_fee: 2850.23 }, // Total knee arthroplasty
  { cpt_code: '27446', non_facility_fee: 2425.67, facility_fee: 2425.67 }, // Partial knee arthroplasty
  { cpt_code: '27130', non_facility_fee: 2635.42, facility_fee: 2635.42 }, // Total hip arthroplasty
  { cpt_code: '27132', non_facility_fee: 2850.89, facility_fee: 2850.89 }, // Total hip revision
  { cpt_code: '29881', non_facility_fee: 1285.47, facility_fee: 1285.47 }, // Knee arthroscopy, meniscectomy
  { cpt_code: '29880', non_facility_fee: 1456.32, facility_fee: 1456.32 }, // Knee arthroscopy, meniscectomy bilateral
  { cpt_code: '29882', non_facility_fee: 1678.54, facility_fee: 1678.54 }, // Knee arthroscopy, meniscus repair
  { cpt_code: '29888', non_facility_fee: 1892.76, facility_fee: 1892.76 }, // ACL reconstruction
  { cpt_code: '23472', non_facility_fee: 2234.56, facility_fee: 2234.56 }, // Total shoulder arthroplasty
  { cpt_code: '23473', non_facility_fee: 2456.78, facility_fee: 2456.78 }, // Reverse total shoulder
  { cpt_code: '22551', non_facility_fee: 3245.67, facility_fee: 3245.67 }, // ACDF single level
  { cpt_code: '22552', non_facility_fee: 1234.56, facility_fee: 1234.56 }, // ACDF additional level
  { cpt_code: '63030', non_facility_fee: 1876.43, facility_fee: 1876.43 }, // Lumbar discectomy
  { cpt_code: '63047', non_facility_fee: 2145.67, facility_fee: 2145.67 }, // Lumbar laminectomy
  { cpt_code: '22612', non_facility_fee: 3567.89, facility_fee: 3567.89 }, // Lumbar fusion
  
  // Fracture care
  { cpt_code: '27236', non_facility_fee: 1567.89, facility_fee: 1567.89 }, // Open treatment hip fracture
  { cpt_code: '27245', non_facility_fee: 1789.45, facility_fee: 1789.45 }, // Intertrochanteric fracture
  { cpt_code: '27506', non_facility_fee: 1456.78, facility_fee: 1456.78 }, // Open treatment femur fracture
  { cpt_code: '27759', non_facility_fee: 1234.56, facility_fee: 1234.56 }, // Open treatment tibia fracture
  
  // E&M codes (from original spreadsheet)
  { cpt_code: '99213', non_facility_fee: 147.72, facility_fee: 98.48 },
  { cpt_code: '99214', non_facility_fee: 221.58, facility_fee: 147.72 },
  { cpt_code: '99215', non_facility_fee: 295.44, facility_fee: 196.96 },
  
  // Physical therapy codes
  { cpt_code: '97110', non_facility_fee: 48.07, facility_fee: 32.05 }, // Therapeutic exercises
  { cpt_code: '97112', non_facility_fee: 48.07, facility_fee: 32.05 }, // Neuromuscular reeducation
  { cpt_code: '97140', non_facility_fee: 44.25, facility_fee: 29.50 }, // Manual therapy
  { cpt_code: '97530', non_facility_fee: 49.27, facility_fee: 32.85 }, // Therapeutic activities
  
  // Injection codes (from original spreadsheet data)
  { cpt_code: '10004', non_facility_fee: 114.11, facility_fee: 93.92 },
  { cpt_code: '10005', non_facility_fee: 279.57, facility_fee: 157.08 },
  { cpt_code: '10006', non_facility_fee: 128.61, facility_fee: 107.08 },
  { cpt_code: '10007', non_facility_fee: 625.72, facility_fee: 192.99 },
  { cpt_code: '10008', non_facility_fee: 295.22, facility_fee: 113.51 },
  { cpt_code: '10009', non_facility_fee: 860.78, facility_fee: 232.87 },
  { cpt_code: '10010', non_facility_fee: 486.53, facility_fee: 157.43 },
  { cpt_code: '10011', coverage_flag: 'BR', non_facility_fee: 0, facility_fee: 0 },
  { cpt_code: '10012', coverage_flag: 'BR', non_facility_fee: 0, facility_fee: 0 },
  { cpt_code: '10021', non_facility_fee: 211.37, facility_fee: 119.17 },
  { cpt_code: '10030', non_facility_fee: 1269.77, facility_fee: 289.22 },
  { cpt_code: '10035', non_facility_fee: 719.93, facility_fee: 179.52 },
  { cpt_code: '10036', non_facility_fee: 581.23, facility_fee: 91.29 },
  { cpt_code: '10040', coverage_flag: 'NRC', non_facility_fee: 241.09, facility_fee: 111.87 },
  { cpt_code: '10060', non_facility_fee: 267.62, facility_fee: 227.24 },
  { cpt_code: '10061', non_facility_fee: 452.22, facility_fee: 393.00 },
  { cpt_code: '10080', coverage_flag: 'NRC', non_facility_fee: 505.82, facility_fee: 224.51 },
  { cpt_code: '10081', coverage_flag: 'NRC', non_facility_fee: 704.70, facility_fee: 369.55 },
  { cpt_code: '10120', non_facility_fee: 315.58, facility_fee: 224.73 },
  { cpt_code: '10121', non_facility_fee: 556.56, facility_fee: 395.04 },
  { cpt_code: '10140', non_facility_fee: 354.83, facility_fee: 254.56 },
  { cpt_code: '10160', non_facility_fee: 272.80, facility_fee: 206.85 },
  { cpt_code: '10180', non_facility_fee: 552.15, facility_fee: 385.92 },
  { cpt_code: '11000', non_facility_fee: 122.75, facility_fee: 58.14 },
  { cpt_code: '11001', non_facility_fee: 56.76, facility_fee: 31.85 },
  { cpt_code: '11004', non_facility_fee: 1227.61, facility_fee: 1227.61 },
  { cpt_code: '11005', non_facility_fee: 1673.32, facility_fee: 1673.32 },
  { cpt_code: '11006', non_facility_fee: 1517.92, facility_fee: 1517.92 },
  { cpt_code: '11008', non_facility_fee: 589.76, facility_fee: 589.76 },
  { cpt_code: '11010', non_facility_fee: 927.95, facility_fee: 594.82 },
  { cpt_code: '11011', non_facility_fee: 1048.02, facility_fee: 644.90 },
  { cpt_code: '11012', non_facility_fee: 1360.56, facility_fee: 896.20 },
];

// Helper to generate SQL INSERT statements for seeding
export function generateSeedSQL(versionId: string): string {
  const values = BWC_2026_SAMPLE_DATA.map(row => {
    const modifier = row.modifier ? `'${row.modifier}'` : 'NULL';
    const modifier_2 = row.modifier_2 ? `'${row.modifier_2}'` : 'NULL';
    const coverage_flag = row.coverage_flag ? `'${row.coverage_flag}'` : 'NULL';
    const non_fac = row.non_facility_fee !== null ? row.non_facility_fee : 'NULL';
    const fac = row.facility_fee !== null ? row.facility_fee : 'NULL';
    
    return `('${versionId}', '${row.cpt_code}', ${modifier}, ${modifier_2}, ${coverage_flag}, ${non_fac}, ${fac})`;
  }).join(',\n');
  
  return `INSERT INTO public.bwc_fee_schedule_entries 
    (version_id, cpt_code, modifier, modifier_2, coverage_flag, non_facility_fee, facility_fee)
  VALUES
    ${values}
  ON CONFLICT (version_id, cpt_code, modifier, modifier_2) DO UPDATE SET
    coverage_flag = EXCLUDED.coverage_flag,
    non_facility_fee = EXCLUDED.non_facility_fee,
    facility_fee = EXCLUDED.facility_fee;`;
}
